import React from "react";
import { Link } from "react-router-dom";
import fb from "../assets/images/Facebook.png";
import insta from "../assets/images/instagram.png";
import sstechLogo from "../assets/images/sslogo_sticky.png";

const Footer = () => {
  return (
    <div className="px-8 lg:px-32 xl:px-52">
      <div className="container mx-auto px-4 py-4">
        <div className="flex flex-wrap justify-between items-center footer-class">
          {/* Left: Text */}
          <div className="text-sm text-black text-class ">
            <div className="flex items-center gap-3 justify-center sm:justify-start">
              <Link
                to="/privacy-policy"
                className="flex items-start hover:text-[#12AD63]"
              >
                Privacy Policy
              </Link>
              <span>|</span>
              <Link
                to="/terms-and-condition"
                className="flex items-start hover:text-[#12AD63]"
              >
                Terms & Conditions
              </Link>
            </div>
            <p>Copyrights © 2026 SSTech System Solutions Pvt Ltd, India</p>
          </div>

          {/* Center: Social Media Icons */}
          <div className="flex space-x-4">
            <a
              href="https://www.facebook.com/profile.php?id=61593186915782#"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={fb} alt="facebook" className="w-10 h-10 social-logo" />
            </a>
            <a
              href="https://www.instagram.com/nutrilensaiofficial/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={insta}
                alt="instagram"
                className="w-10 h-10 social-logo"
              />
            </a>
          </div>

          {/* Right: Logo */}
          <a
            href="https://www.sstechsystem.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={sstechLogo}
              alt="sstechLogo"
              className="w-28 h-12 sstech-logo"
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
